<template>
  <v-dialog v-model="dialog" width="800px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Top.PushError.title") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>

      <!-- 表格 -->
      <v-data-table
        :headers="deliveryErrorsHeaders"
        :items="deliveryErrors"
        multi-sort
        class="elevation-0 px-6"
        :footer-props="
          Object.assign({}, $t('$config.footer-props'), {
            itemsPerPageOptions: [5],
          })
        "
      >
        <template v-slot:item.error_msg="{ item }">
          <span class="red--text">
            {{ item.error_msg }}
          </span>
        </template>
        <template v-slot:item.order_code="{ item }">
          <span v-for="(error, index) in item.errors" :key="index">
            <a
              :href="'/#/orders/' + error.id"
              style="text-decoration: none"
            >
              {{ error.order_code }}
            </a>
          </span>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

export default {
  name: "DeliveryErrDialog",

  components: {},

  props: {
    value: Boolean,
    deliveryErrors: Array,
  },
  mounted() {},

  computed: {
    deliveryErrorsHeaders: () => [
      {
        text: i18n.t("Top.PushError.deliveryErrorFields.order_code"),
        align: "start",
        value: "order_code",
        sortable: false,
      },
      {
        text: i18n.t("Top.PushError.deliveryErrorFields.err_msg"),
        align: "center",
        value: "error_msg",
        sortable: false,
        width: "100px",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },

  methods: {},
};
</script>
